// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"b9fcb90d","114":"6b0ff931","134":"40758b53","159":"20d46999","178":"ee43cea0","193":"37a8a151","236":"4081abe5","288":"9e8493b7","318":"1df09572","326":"ffec7c13","526":"312ea076","559":"e97097fd","615":"c34a0c2b","616":"f89b87a9","902":"dec0c7a1","942":"70ae7a2a"}[chunkId] + ".chunk.js";
};